import React, { useContext, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import Settings from './Settings'
import Recitations from './Recitations';
import Alarms from './Alarms';
import { AppContext } from '../AppContext';
import { FontAwesome } from '../data/FontAwesome';


export default function Menu() {

    const { showMenu, setShowMenu, deviceSettings, refreshClock, t, isRtl } = useContext(AppContext)
    const [activeTab, setActiveTab] = useState('settings')

    const tabClass = (tab) => 'nav-link fs-4' + (activeTab === tab ? ' active' : '')

    return (
        <Offcanvas placement="end" scroll="false" show={showMenu} onHide={() => setShowMenu(false)} className={'bg-dark azan-menu ' + (isRtl ? 'app-rtl' : '')}>
            <Offcanvas.Header className='azan-menu-header'>
                <div className='d-flex flex-row w-100 align-items-center justify-content-between'>
                    <div id='topMenu'>
                        <ul className="nav nav-pills">
                            <li className='nav-item'>
                                <button title={t('menu.settings')} className={tabClass('settings')} type="button"
                                    onClick={() => setActiveTab('settings')}>
                                    {FontAwesome.Gear}
                                </button>
                            </li>

                            {navigator.onLine ? (<li className='nav-item'>
                                <button title={t('menu.recitations')} className={tabClass('recitations')} type="button"
                                    onClick={() => setActiveTab('recitations')}>
                                    {FontAwesome.Book}
                                </button>
                            </li>) : null}

                            {deviceSettings.azanCallsEnabled === 'Y' ? (<li className='nav-item'>
                                <button title={t('menu.alarms')} className={tabClass('alarms')} type="button"
                                    onClick={() => setActiveTab('alarms')}>
                                    {FontAwesome.Bell}
                                </button>
                            </li>) : null}

                        </ul>
                    </div>
                    <div className='px-2'>
                        <span title={t('menu.close')} onClick={() => { setShowMenu(false) }} className="pointer azan-menu-close">
                            {FontAwesome.Close}
                        </span>
                    </div>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className='azan-menu-body'>
                <div className="tab-content pt-0">
                    {activeTab === 'settings' ? (<div>
                        <div className='azan-menu-content'>
                            <Settings />
                            <div className='settings-actions'>

                                {!navigator.onLine ? (<div>
                                    <span title={t('common.offlineHint')} className='badge'>
                                        {FontAwesome.Plug} {t('common.offline')}
                                    </span>
                                </div>) : null}

                                {navigator.onLine ? (<div className='flex-fill'>
                                    <button className='settings-action-btn settings-action-refresh' type='button' onClick={refreshClock}>
                                        <span>{FontAwesome.Reset}</span>{t('common.refresh')}
                                    </button>
                                </div>) : null}

                                {navigator.onLine ? (<div className='flex-fill'>
                                    <a className='settings-action-btn settings-action-reset' href="/reset/">
                                        <span>{FontAwesome.Reset}</span>{t('common.reset')}
                                    </a>
                                </div>) : null}

                            </div>
                        </div>
                    </div>) : null}
                    {activeTab === 'recitations' ? (<div>
                        <div className='azan-menu-content text-light'>
                            <Recitations />
                        </div>
                    </div>) : null}
                    {activeTab === 'alarms' ? (<div>
                        <div className='azan-menu-content text-light'>
                            <Alarms />
                        </div>
                    </div>) : null}
                </div>
            </Offcanvas.Body>
        </Offcanvas >
    )
}



